import styled from "styled-components";
import { Button as AntButton } from "antd";

export const RootContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 34px 16px;
`;

export const TypeContainer = styled.div`
  width: 100%;
`

export const ShareItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 16px;
  width: 100%;
`;

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: 100%;
  padding: 16px;
  border-radius: 8px;
  background: #FFF;
  box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.10);
`;

export const Title = styled.div`
  color: #2A2A2A;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 26px; /* 162.5% */

  margin-bottom: 8px;;
`;

export const PointContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-top: 16px;
`;

export const Point = styled.div`
  overflow: hidden;
  color: #2A2A2A;
  text-overflow: ellipsis;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 26px; /* 162.5% */

  @media screen and (max-width: 400px) {
    font-size: 14px;
  }

  @media screen and (max-width: 350px) {
    font-size: 12px;
  }
`;

export const Collect = styled(AntButton)`
  border-radius: 8px;
  font-size: 12px;
  padding: 1px 8px;
  height: 30px;

  :disabled{
    opacity: 0.5;
  }

  @media screen and (max-width: 400px) {
    font-size: 10px;
  }
`;

export const Divider = styled.div`
  width: 100%;
  border-bottom: 1px dashed #F4F4F4;
  height: 1px;
  margin: 16px 0px;
`;

export const TextBtn = styled(AntButton)`
  background: transparent !important;
  padding: 0;

  overflow: hidden;
  color: #D66700;
  text-overflow: ellipsis;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 26px; /* 162.5% */

  svg{
    width: 24px;
    height: 24px;
  }

  :hover{
    background: transparent !important;
  }

  @media screen and (max-width: 400px) {
    font-size: 14px;
    
    svg{
      width: 20px;
      height: 20px;
    }
  }

  @media screen and (max-width: 350px) {
    font-size: 12px;
  }
`

export const StepsContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 112%;
  margin-left: 10%;
`;

export const StepBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 25%;
`;

export const IconBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 30px;

  position: relative;
  
  svg{
    width: 40px !important;
    height: 40px !important;
  }

  @media screen and (max-width: 400px) {
    svg{
      width: 30px !important;
      height: 30px !important;
    }
  }
`;

export const Number = styled.p`
  width: 40px;
  margin-top: 8px;

  color: #000;
  text-align: center;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

export const FinishLine = styled.div`
  height: 4px;
  background: linear-gradient(133deg, #FFD648 -3.8%, #AA5E1B 100%);
  width: ${(props) => props.width === 0 ? '0px'
    : props.width === 100 ? `calc(${props.width}% - 40px)`
      : `calc(${props.width}% - ${props.width * 20 / 100}%)`};

  @media screen and (max-width: 400px) {
    width: ${(props) => props.width === 0 ? '0px'
    : props.width === 100 ? `calc(${props.width}% - 30px)`
      : `calc(${props.width}% - ${props.width * 15 / 100}%)`};
  }
`;

export const UnfinishLine = styled.div`
  height: 4px;
  background-color: #F4F4F4;
  width: ${(props) =>
    props.width === 100 ? `calc(${props.width}% - 40px)`
      : props.width === 0 ? '0px'
      : `calc(${props.width}% - ${props.width * 20 / 100}%)`};

  @media screen and (max-width: 400px) {
    width: ${(props) =>
      props.width === 100 ? `calc(${props.width}% - 30px)`
        : props.width === 0 ? '0px'
        : `calc(${props.width}% - ${props.width * 15 / 100}%)`};
  }
`;

export const CurrentMilestone = styled.p`
  position: absolute;
  top: 0;
  right: calc(50% - 20px);

  color: #2A2A2A;
  font-size: 8px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

export const Loader = styled.div`
	width: 100%;
	height: calc(100vh - 68px);
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const EmptyBox = styled.div`
	width: 100%;
	height: calc(100vh - 70px);
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
`;

export const NoResultText = styled.div`
  color: #2A2A2A;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 28px; /* 155.556% */
`;

export const ShareItemBottomContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`
